export default "__VITE_ASSET__DrphcTT___"